var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmOrderIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.3167V6.84341C4 4.5602 4 3.4186 4.70295 2.7093C5.40589 2 6.53726 2 8.80001 2H12C14.2627 2 15.3941 2 16.0971 2.7093C16.8 3.4186 16.8 4.5602 16.8 6.84341V15.3167C16.8 16.526 16.8 17.1307 16.4304 17.3687C15.8265 17.7577 14.8929 16.9419 14.4233 16.6459C14.0353 16.4011 13.8414 16.2788 13.626 16.2718C13.3934 16.2641 13.1959 16.3815 12.7767 16.6459L11.248 17.6099C10.8356 17.8699 10.6294 18 10.4 18C10.1706 18 9.96441 17.8699 9.55201 17.6099L8.02331 16.6459C7.63532 16.4011 7.44133 16.2788 7.22603 16.2718C6.99338 16.2641 6.79595 16.3815 6.3767 16.6459C5.90716 16.9419 4.9735 17.7577 4.36956 17.3687C4 17.1307 4 16.526 4 15.3167Z",
    fill: "white",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59995 9.20007H7.19995",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H7.19995",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmOrderIc);
export default __webpack_public_path__ + "static/media/confirm_order_ic.b42fc2fbbf7a5299c4ad8bebe45500a0.svg";
export { ForwardRef as ReactComponent };